// extracted by mini-css-extract-plugin
export default {"inputEdit":"Primitives-GenericModalSection-module__inputEdit--Ua1UC"};